<template>
  <div class="questionComp">
    <nav-local-comp :all="'Опрос'" :id="id" :toAll="toAll"/>
    <question-crud-comp/>
  </div>
</template>

<script>
export default {
  name: 'questionComp',
  props: {
  },
  data: function () {
    return {
      moduleName: 'questions',
      required: null
    }
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getOne`, { required: this.required })
  },
  components: {
  },
  computed: {
    id: function () { return this.$store.getters[`${this.moduleName}/getId`] },
    tabs: function () { return this.$store.getters[`${this.moduleName}/getTabs`] }
  },
  methods: {
    toAll () {
      this.$store.dispatch(`${this.moduleName}/toAll`)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
